import { Injectable } from '@angular/core';
import { ApiService, PagedSearch, PagedResult, PagedResultGeneric } from '../../shared/index'; //app/shared/index barrel;
import { HtmlTemplate } from './html-template.model';
import { IHtmlTemplateService } from './ihtml-template.service';

@Injectable()
export class HtmlTemplateService implements IHtmlTemplateService {
  public _apiService: ApiService;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  get(htmlTemplateId: number) {
    return this._apiService.get(`HtmlTemplate/${htmlTemplateId}`);
  }

  create(htmlTemplate: HtmlTemplate): Promise<any> {
    return this._apiService.post('HtmlTemplate', htmlTemplate);
  }

  update(htmlTemplate: HtmlTemplate): Promise<any> {
    return this._apiService.put('HtmlTemplate', htmlTemplate);
  }

  delete(id: number): Promise<any> {
    return this._apiService.delete(`HtmlTemplate/${id}`);
  }

  public getHtmlTemplates = (): Promise<Array<HtmlTemplate>> => {
    const url = 'HtmlTemplates';
    return this._apiService.get(url);
  };

  public search = (params: PagedSearch): Promise<PagedResultGeneric<HtmlTemplate>> => {
    const url = 'HtmlTemplates/search';
    const cacheOptions = this._apiService.getDefaultApiCacheOptionsForNoCache();
    return this._apiService.getPaged(url, params, cacheOptions);
  };

  public getHtmlTemplatesForUser = (userNum: number): Promise<Array<HtmlTemplate>> => {
    const url = 'User/' + userNum.toString() + '/HtmlTemplates';
    return this._apiService.get(url);
  };
}
